import React, { useState } from 'react';
import { connect } from 'react-redux';

import ArmyListExportDetail from './mode/ArmyListExportDetail';
import ArmyListExportSmall from './mode/ArmyListExportSmall';
import ArmyListExportWarhall from './mode/ArmyListExportWarhall';
import ArmyListExportWithRate from './mode/ArmyListExportWithRate';

import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import ArmyListFileExport from './ArmyListFileExport';
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import Repeater from '@Utils/Repeater';
import {
  ArmyListExportGameHelpersPresenter
} from '@Selectors/builder/myArmyList/export/army-list-export-game-helpers.presenter';
import ArmyListExportOldWorld from '@Builder/myArmyList/export/mode/ArmyListExportOldWorld';

const ArmyListExport: React.FC<ArmyListExportProps> = ({armyId, hasArmySpell, magicPathIds}) => {
  const [currentActiveTab, setCurrentActiveTab] = useState('1');
  const [currentSubActiveTab, setCurrentSubActiveTab] = useState('A');

  // Toggle active state for Tab
  const toggleTab = (tab: string) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };
  const toggleSubTab = (tab: string) => {
    if (currentSubActiveTab !== tab) setCurrentSubActiveTab(tab);
  };

  const locale = document.documentElement.lang || 'en';

  return (
    <Row className={'builder-edit-app justify-content-center'}>
      <Col xs={12}>
        <h2><FormattedMessage {...defaultMessages.toolGameHelp} /></h2>
      </Col>
      <Col xs={12} md={3} lg={3} className={'text-center'}>
        <a href={`/${locale}/ninth_age/armies/${armyId}/full`} className={'btn btn-round-dark btn-sm w-100 p-3 m-1'}
           target="_blank"><i className="fa-solid fa-2x fa-book-open-reader"></i>
          <FormattedMessage {...defaultMessages.armyArmybook} /></a>
      </Col>
      <Col xs={12} md={3} lg={3} className={'text-center'}>
        <a href={`/${locale}/ninth_age/armies/${armyId}/quick-references`}
           className={'btn btn-round-dark btn-sm w-100 p-3 m-1'}
           target="_blank"><i className="fa-solid fa-2x fa-book-open-reader"></i>
          <FormattedMessage {...defaultMessages.ninthAgeArmyQuikReferenceSheet} /></a>
      </Col>
      <Col xs={12} md={3} lg={3} className={'text-center'}>
        <a href={`/${locale}/ninth_age/armies/${armyId}/translation-references`}
           className={'btn btn-round-dark btn-sm w-100 p-3 m-1'}
           target="_blank"><i className="fa-solid fa-2x fa-book-open-reader"></i>
          <FormattedMessage {...defaultMessages.ninthAgeArmyTranslationReferenceSheetTitle} /></a>
      </Col>
      {hasArmySpell && (<Col xs={12} md={3} lg={3} className={'text-center'}>
        <a href={`/${locale}/ninth_age/armies/${armyId}/cards`} className={'btn btn-round-dark btn-sm w-100 p-3 m-1'}
           target="_blank"><i className="fa-solid fa-2x fa-hat-wizard"></i>
          <FormattedMessage {...defaultMessages.ninthAgeArmyMagicCards} /></a>
      </Col>)}
      <Repeater data={magicPathIds} indexPrefix={'magic-path'}>
        {
          (path: { id: number, name: string }) => (
            <Col xs={12} md={3} lg={3} className={'text-center'}>
              <a href={`/${locale}/ninth_age/magic_paths/${path.id}/cards`}
                 className={'btn btn-round-dark btn-sm w-100 p-3 m-1'}
                 target="_blank"><i className="fa-solid fa-2x fa-hat-wizard"></i>
                <FormattedMessage {...defaultMessages.ninthAgeMagicPathMagicCards} />: {path.name}</a>
            </Col>
          )
        }
      </Repeater>

      <Col xs={12} className={'mt-3'}>
        <h2><FormattedMessage {...defaultMessages.armyListExportTitle} /></h2>
      </Col>
      <Col xs={12} md={10} className={'offset-md-1'}>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: currentActiveTab === '1' })}
                     onClick={() => toggleTab('1')}>TXT</NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={classnames({ active: currentActiveTab === '2' })}
                     onClick={() => toggleTab('2')}>HTML/PDF</NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={currentActiveTab}>
          <TabPane tabId="1">
            <Nav tabs>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'A' })}
                         onClick={() => toggleSubTab('A')}>Small</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'B' })}
                         onClick={() => toggleSubTab('B')}>Warhall</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'F' })}
                         onClick={() => toggleSubTab('F')}>Old World</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'G' })}
                         onClick={() => toggleSubTab('G')}>Discord / Markdown</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'C' })}
                         onClick={() => toggleSubTab('C')}>With details</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'D' })}
                         onClick={() => toggleSubTab('D')}>Without %</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: currentSubActiveTab === 'E' })}
                         onClick={() => toggleSubTab('E')}>With %</NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={currentSubActiveTab}>
              <TabPane tabId="A">
                <ArmyListExportSmall />
              </TabPane>
              <TabPane tabId="B">
                <ArmyListExportWarhall />
              </TabPane>
              <TabPane tabId="C">
                <ArmyListExportDetail />
              </TabPane>
              <TabPane tabId="D">
                <ArmyListExportWithRate rate={false} />
              </TabPane>
              <TabPane tabId="E">
                <ArmyListExportWithRate rate={true} />
              </TabPane>
              <TabPane tabId="F">
                <ArmyListExportOldWorld markdown={false} />
              </TabPane>
              <TabPane tabId="G">
                <ArmyListExportOldWorld markdown={true} />
              </TabPane>
            </TabContent>
          </TabPane>
          <TabPane tabId="2">
            <ArmyListFileExport />
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state: AppState) => ({
  ...ArmyListExportGameHelpersPresenter(state),
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListExport);

type ArmyListExportProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
